// import { Api } from '@/service';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import config from '@/config';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import vSelect from 'vue-select';
import PictureInput from 'vue-picture-input' // https://github.com/alessiomaffeis/vue-picture-input good boy

import { service as setting } from '@/service/api/setting'

let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: '', sv: '', skt: '', opt : {}, adv : false
  }
}

const i18n_fields = {
  EN: [
    { key: 'id', thStyle: 'width: 10%', label: '#.' },
    { key: 'is_alive', sortable: true, label: 'Status'},
    { key: 'name', sortable: true, label: 'Name'},
    { key: 'list_price', sortable: true, label: 'Public price' },
    { key: 'min_price', label: 'Cost price', sortable: true },
    { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  },
  ],
  KO: [
    { key: 'id', thStyle: 'width: 10%', label: '#.' },
    { key: 'is_alive', sortable: true, label: '상태'},
    { key: 'name', sortable: true, label: '서비스명'},
    { key: 'list_price', sortable: true, label: '공시 가격' },
    { key: 'min_price', label: '가격', sortable: true },
    { key: 'func', label: '더보기', sortable: false, thStyle: 'width: 10%'  },
  ]
}

export default {

  components: { DatePicker, cSwitch, vSelect, PictureInput },
  name : "ServiceList",
  props : ["auto_refresh", "enable_new", "view_detail"],
  data: () => ({
    config,
    loading : false,
    lock : true,
    confirm_refresh : false,
    confirm_all : false,
    confirm_info: false,
    confirm_toggle : false,
    confirm_delete : false,
    confirm_save : false,
    type : '',
    toggle : 'password',
    custom,
    codes,
    service_new : false,
    service : {},
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0,
      license : { data : {}, data_json : { key : {}, info : {} }, list : [] },
      logo : { data : { slogan : '', image : ''} },
      mail : { data : {} },
      rule : { data : {} }
    },
    sync : { interval : 15, stop : false, th : undefined },
  }),
  computed: {
    url() { return `https://${location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual}` },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n]
    },
  },
  methods: {
    cancel() {
      if(this.$refs._list) { this.$refs._list.refresh() }
      this.confirm_toggle = false
    },
    detail(item) {
      try {
        if(this.view_detail != false) {
          this.lock = true
          this.service = item
          this.service.use_wmds = this.service.wmds_site > 0 ?  true  : false
          this.service.use_waf = this.service.waf > 0 ?  true  : false
          this.service.use_wsfinder = this.service.wsfinder > 0 ?  true  : false
          this.service.use_integrity = this.service.integrity > 0 ?  true  : false

          // add

          this.service.target_domain = this.service.target_domain
          this.service.email_support = this.service.email_support

          this.service.use_wsfinder_analysis = this.service.wsfinder_analysis == 1
          this.service.use_wmds_analysis = this.service.wmds_analysis == 1

          this.service.use_technical_support = this.service.technical_support == 1
          this.service.use_install_support = this.service.install_support == 1
          this.service.use_policy_support = this.service.policy_support == 1
          this.service.use_phone_support = this.service.phone_support == 1


          console.log(item)

          this.confirm_info = true
        } else {
          console.log("item : ", item.id)
          this.$root.$emit('get_basic_service', item.id)
        }
      } catch (e) { console.log(e) }
    },
    async load_service(ctx = {}) {
      try {
        // let so = { target : 'service', cmd : 'list', body : { and : [{ name : 'is_del', value : false, op : '=' }] } }
       
        let so = {
          body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
          offset : (this.so.currentPage-1 || 0) * this.so.perPage, limit: this.so.perPage, // 10 은 나중에 변수 처리해야함.
        }
        
        if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
        // let rs = await Api.Manager(so);
        let rs = await setting.listService(so);
        if(rs.error) { this.$toastr.e("failed", rs.reason); return [] }
        this.so.totalRows = rs.total;
        if(rs.body) {
          rs.body.forEach(r => {
            r.status = r.is_alive;
          });
          return rs.body
        }
        return []
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
    async upsert_service() {
      try {
        if(!this.service.min_price || this.service.min_price < 0 || typeof this.service.min_price == 'undefined') {
          return this.$toastr.e("Cost price", "not a number")
        } else { this.service.min_price = typeof this.service.min_price != 'number' ? this.service.min_price : this.service.min_price.toFixed(2) }
        if(!this.service.list_price || this.service.list_price < 0 || typeof this.service.list_price == 'undefined') {
          return this.$toastr.e("Public price", "not a number")
        } else { this.service.list_price = typeof this.service.list_price != 'number' ? this.service.list_price : this.service.list_price.toFixed(2) }

        // convert
        this.service.wmds_site = this.service.use_wmds == true ? 1 : 0
        this.service.wsfinder = this.service.use_wsfinder == true ? 1 : 0
        this.service.waf = this.service.use_waf == true ? 1 : 0
        this.service.integrity = this.service.use_integrity == true ? 1 : 0

        // add
        this.service.wsfinder_analysis = this.service.use_wsfinder_analysis == true ? 1 : 0 // boolean
        this.service.wmds_analysis = this.service.use_wmds_analysis == true ? 1 : 0 // boolean

        this.service.target_domain = this.service.target_domain // number
        this.service.technical_support = this.service.use_technical_support == true ? 1 : 0 // boolean
        this.service.install_support = this.service.use_install_support == true ? 1 : 0 // boolean
        this.service.policy_support = this.service.use_policy_support == true ? 1 : 0 // boolean
        this.service.phone_support = this.service.use_phone_support == true ? 1 : 0 // boolean
        this.service.email_support = this.service.email_support // number


        // let rs = await Api.Manager({ target : 'service', cmd : this.service_new ? 'insert' : 'update', body : this.service });

        let check_id = '';
        check_id = this.service_new ? 'insert' : 'update'

        if(check_id == 'update'){
          let rs = await setting.updateService(this.service);

          if(rs.error) { this.$toastr.e(this.service_new ? 'create' : 'update' + " failed", rs.reason); }
          else { this.$toastr.s("saved", this.$route.name); }
          this.service_new = false;
          this.confirm_info = false;
          this.confirm_all = false;
          this.$refs._list.refresh()
        }else{
          if(check_id == 'insert'){
            console.log('isnert')
            let rs = await setting.insertService(this.service);

            if(rs.error) { this.$toastr.e(this.service_new ? 'create' : 'update' + " failed", rs.reason); }
            else { this.$toastr.s("saved", this.$route.name); }
            this.service_new = false;
            this.confirm_info = false;
            this.confirm_all = false;
            this.$refs._list.refresh()
          }
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
    async toggle_service() {
      try {

        if(!this.service.name) { return this.$toastr.e("select first") }
        this.confirm_toggle = false;

        // let rs = await Api.Manager({ target : 'service', cmd : 'update', body : Object.assign({}, this.service ) });
        let rs = await setting.updateService(Object.assign({}, this.service ));
        if(rs.error) { this.$toastr.e("failed", rs.reason); }
        else { this.$toastr.s("saved", this.$route.name); }
        this.$refs._list.refresh()
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
    async delete_service() {
      try {
        if(!this.service.name) { return this.$toastr.e("select first") }
        // let rs = await Api.Manager({ target : 'service', cmd : 'delete', body : this.service });
        let rs = await setting.deleteService(this.service );
        if(rs.error) { this.$toastr.e("failed", rs.reason); }
        else { this.$toastr.s("saved", this.$route.name); }
        this.$refs._list.refresh()
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
    status_change($event, item, type) {
      if($event == item.is_alive) { console.log("is loading"); return; }
      this.service = item
      this.service.is_alive = $event;

      if(type == 'is_del') {
        this.confirm_delete = true
      } else {
        this.confirm_toggle = true;
      }

    },
    list() { this.$emit('refresh'); },
  },
  created() { console.log('group.list.vue', 'created'); },
  destroyed() { console.log('group.list.vue', 'destroyed'); },
  mounted() { console.log('group.list.vue', 'mounted'); },
}